<!-- Company/Branch Header (trigger for panel) -->
<div
    class="side-nav-company"
    (click)="togglePanel($event)"
>
    <img
        *ngIf="tenantImageUrl && tenantImageUrl !== 'null' && tenantImageUrl !== ''"
        class="company-logo"
        [src]="tenantImageUrl"
        (error)="onLogoError()"
    />
    <div
        *ngIf="!tenantImageUrl || tenantImageUrl === 'null' || tenantImageUrl === ''"
        class="company-logo backlogo"
    ></div>
    <div class="company-info">
        <span class="company-name">{{ companyName }}</span>
        <span class="branch-name">
            {{ branchName }}
            <lucide-icon name="chevron-down" [size]="14" class="chevron-icon" [class.open]="isPanelOpen"></lucide-icon>
        </span>
    </div>
</div>

<!-- Business/Branch Switcher Panel -->
<popup-panel [isOpen]="isPanelOpen" (closed)="closePanel()" panelClass="business-switcher-panel">
    <div class="business-switcher">
        <div class="switcher-section" *ngIf="tenants && tenants.length > 0">
            <span class="section-label">{{ 'layout.sidenav.switch-business' | translate }}</span>
            <div
                *ngFor="let tenant of tenants"
                class="tenant-item"
                [class.selected]="tenant.id == currentTenantId"
                (click)="switchTenant(tenant)"
            >
                <mat-icon *ngIf="tenant.id == currentTenantId" class="check-icon">check</mat-icon>
                <span>{{ tenant.name }}</span>
            </div>
        </div>
        <div class="switcher-section branch-switcher-section" *ngIf="branches && branches.length > 1">
            <span class="section-label">{{ 'layout.sidenav.switch-branch' | translate }}</span>
            <mat-form-field class="branch-select">
                <mat-select
                    [(ngModel)]="selectedBranch"
                    (ngModelChange)="changeSelectedBranch($event)"
                >
                    <mat-option
                        *ngFor="let branch of branches"
                        [value]="branch.id"
                    >
                        {{ branch.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</popup-panel>
